import React, { useState, Fragment } from "react";
import Box from "@mui/material/Box";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./OrderForm.css";
import OrderHeader from "../../components/OrderHeader/OrderHeader";
import { Button, Modal } from "react-bootstrap";
import Steps from "../../components/Steps/Steps";
import { useEffect } from "react";

const steps = [
  "MEDICAL CANVASSING  ",
  "RECORDS REQUEST  ",
  "SOCIAL CANVASSING  ",
  "REQUESTOR INFORMATION  ",
  "CLAIMANT INFORMATION  ",
  "ORDER REVIEW",
];

export default function OrderForm() {
  const [activeStep, setActiveStep] = useState(0);
  const [show, setShow] = useState(false);
  const [error, setError] = useState({
    message: null,
    isError: false,
  });

  // Scroll top when the active page changed
  useEffect(() => {
    document.getElementById("root").scrollIntoView({behavior: "smooth"})
  }, [activeStep])

  const handleShow = (msg) => {
    setShow(true);

    if (msg) {
      setError({ message: msg, isError: true });
    } else {
      setError({ message: null, isError: false });
    }
  };

  const handleClose = () => {
    setShow(false);
    !error.isError && window.location.reload();
  };
  return (
    <Box className="margin-top">
      <OrderHeader />

      <Fragment>
        <Steps
          steps={steps}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          showModal={handleShow}
        />
      </Fragment>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="title">
          <Modal.Title>Order Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="body">
          <span className={error.isError ? "text-danger" : ""}>
            {error.message ??
              "Thank you for your order. Once your order has been processed and verified, you will receive a confirmation email."}
          </span>
        </Modal.Body>
        <Modal.Footer className="footer">
          <Button variant="primary" className="ok-button" onClick={handleClose}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </Box>
  );
}
